module.exports = __webpack_public_path__ + "static/media/round-cancel-24px.47fd8269.svg";